// extracted by mini-css-extract-plugin
export default {"withSeparator":"NftOtherInfoWithSeparator_withSeparator__Koirl"};